var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebookGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.142 19.025V10.28H.388V7.132h2.754v-2.69C3.142 2.33 4.769.39 8.518.39c1.518 0 2.64.122 2.64.122l-.088 2.94s-1.145-.01-2.394-.01c-1.352 0-1.569.524-1.569 1.392v2.299h4.07L11 10.28H7.107v8.745H3.142z",
    fill: "url(#facebook-gradient_svg__paint0_linear_1924_26438)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "facebook-gradient_svg__paint0_linear_1924_26438",
    x1: 6.417,
    y1: 35.388,
    x2: 16.193,
    y2: 32.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#01D6B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#218FEE"
  })))));
}

export default SvgFacebookGradient;